<section class="w-full">

    <split-header-section title="Exames">
        <p-button label="Cadastrar Exame" (click)="cadastrarExame()" severity="primary"></p-button>
    </split-header-section>
    
    <div [style.padding-right]="'16.002px'" [style.padding-left]="'16.002px'" class="w-full">
        <split-card>
            <div card-header class="grid">
                <div class="col-3">
                    <split-search (valueChange)="filterName($event)"></split-search>
                </div>
                <div class="col-9 flex justify-content-end">
                    <!-- <split-button-filter></split-button-filter> -->
                    <!-- <split-button-filters [(filters)]="filters"></split-button-filters> -->
                </div>
            </div>

            <ng-container card-body>
                <div *ngIf="(isLoading$ | async)" class="flex align-items-center justify-content-center">
                    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
                </div>
            </ng-container>

            <split-table 
                [hidden]="(isLoading$ | async)"
                (pageChange)="onPageChange($event)"
                [totalRecords]="totalRecords"
                [rows]="30" 
                [paginator]="true" 
                card-body 
                [filters]="filters" 
                [checklist]="false"
                [widthColumns]="[]" 
                [dados]="(lista$ | async)!" 
                theme="primary" 
                [widthColumns]="[5, 30, 20, 15, 20, 10]"  
                >

                <ng-template #header> Id </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item.active? 'inativo': ''">
                        {{item.id}}
                    </div>
                </ng-template>

                <ng-template #header> <div [style.padding-left]="'10px'" class="text-left">Exame</div> </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div class="text-left exam_name" [ngClass]="!item.active? 'inativo': ''">
                        {{item.name}}
                    </div>
                </ng-template>

                <ng-template #header> Unidade </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item.active? 'inativo': ''">
                        {{item.unit.unitName}}
                    </div>
                </ng-template>

                <ng-template #header>Valor(R$)</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item.active? 'inativo': ''">
                        {{item.value | currency:'BRL':'symbol':'1.2-2'}}
                    </div>
                </ng-template>

                <!-- <ng-template #header>Unidades</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item.active? 'inativo': ''">
                        {{item.units[0]?.unitName}}
                        <p-badge *ngIf="item.units.length-1 > 0" class="pl-1" [pTooltip]="tooltipContent"
                            tooltipPosition="bottom" value="+{{item.units.length - 1}}"></p-badge>
                        <ng-template #tooltipContent>
                            <div class="flex flex-column justify-content-start align-items-start">
                                <span class="p-0 text- py-1" *ngFor="let unidade of item.units.slice(1)">
                                    {{unidade.unitName}}
                                </span>
                            </div>
                        </ng-template>
                    </div>
                </ng-template> -->

                <ng-template #header>Tempo de Entrega</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div [ngClass]="!item.active? 'inativo': ''">
                        <ng-container *ngIf="item.deliveryTime > 1">
                            {{item.deliveryTime}} Dias
                        </ng-container>

                        <ng-container *ngIf="item.deliveryTime == 1">
                            {{item.deliveryTime}} Dia
                        </ng-container>
                    </div>
                </ng-template>

                <ng-template #header></ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    <div class="w-auto flex justify-content-end">
                        <button [ngClass]="!item.active? 'inativo': ''"
                            class="action border-circle bg-white w-2rem h-2rem mr-4" (click)="editarExame(item)"
                            pTooltip="Editar Exame">
                            <img src="assets/lista-unidade/editar.svg" alt="editar exame" />
                        </button>
                        <ng-template [ngIf]="item.active">
                            <button class="action border-circle bg-white w-2rem h-2rem mr-4"
                                (click)="inativarExame(item)" pTooltip="Inativar Exame">
                                <img src="assets/lista-unidade/inativar.svg" alt="Inativar Exame" />
                            </button>
                        </ng-template>
                        <ng-template [ngIf]="!item.active">
                            <button class="action border-circle bg-white w-2rem h-2rem mr-4"  pTooltip="Ativar Exame" (click)="ativarExame(item)"
                                >
                                <img src="assets/cadastro/active.svg" alt="ativar exame" />
                            </button>
                        </ng-template>

                        <button class="action border-circle bg-white w-2rem h-2rem mr-4" (click)="deletarExame(item.id)"
                            pTooltip="Deletar Exame">
                            <img src="assets/lista-unidade/excluir.svg" alt="excluir exame" />
                        </button>
                    </div>
                </ng-template>

            </split-table>




        </split-card>
    </div>

</section>


<!-- ---------------------------------------------- -->

<!-- dialog confirmação deletar / inativar -->

<!-- ---------------------------------------------- -->

<p-dialog [(visible)]="mostrarModalDeletar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar unidade">
        <span class="title">
            <p>Tem certeza que deseja deletar</p>
            <p>esse Exame?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você excluirá permanentemente</p>
            <p>o Exame selecionado</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="deletar" (click)="onDelete()">Deletar</button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar unidade">
        <span class="title">
            <p>Tem certeza que deseja inativar</p>
            <p>esse Exame?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você inativará esse exame da sua listagem</p>
            <p>padrão.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="inativar" (click)="inativarExamePatch()">Inativar</button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/cadastro/active_modal.svg" alt="imagem deletar unidade">
        <span class="title">
            <p>Tem certeza que deseja ativar</p>
            <p>esse Exame?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você irá ativar esse exame na sua listagem</p>
            <p>padrão</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="ativar" (click)="ativarExamePatch()">Ativar</button>
    </ng-template>

</p-dialog>